// JobCostMemberClockInTimer.jsx
import React, { useEffect, useState } from 'react';
import faker from 'faker';
import PropTypes from 'prop-types';
import {
  Box,
  Stack,
  Card,
  Avatar,
  CardHeader,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Grid,
  Divider,
  Skeleton,
  Tooltip,
  CircularProgress
} from '@material-ui/core';
import { Add, Remove, EditOutlined, Done as DoneIcon } from '@material-ui/icons';
import Scrollbar from 'src/components/Scrollbar';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import axios from 'axios';
import moment from 'moment';
import { useSnackbar } from 'notistack';


// ----------------------------------------------------------------------
function LaborerRow({ person, showDivider, loading,projectData }) {
  return (
    <Box>
      <Stack direction="row" alignItems="flex-start" spacing={2} sx={{ py: 0.8, mt: 1, }}>
        <>
          <Avatar alt={person.staff_name} src={person.user_profile_pic} />
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Tooltip title={person.staff_name}>
              <Typography variant="subtitle2" noWrap sx={{ maxWidth: 140, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                {person.staff_name}
              </Typography>
            </Tooltip>
            <Stack direction={{ xs: 'column', md: 'row' }} justifyContent={{ xs: 'flex-start', md: 'space-between' }}>
              {person?.installation ? (
                <Tooltip title={`Installation: ${person.installation_name} (Install Labor)`}>
                 <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: 140, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                  <>
                      <Box component="span" color="text.secondary">
                      Installation:{' '}
                      </Box>
                      <Box component="span" color="yellow">
                      {person.installation_name ? `${person.installation_name} (Install Labor)` : 'Install Labor'}
                      </Box>
                    </>
                {/* <Typography variant="span" color="yellow" noWrap sx={{ maxWidth: 140, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                  {person.installation_name ? `Installation: ${person.installation_name} (Install Labor)` : 'Install Labor'}
                </Typography> */}
                </Typography>
                </Tooltip>
              
              ) : <Tooltip title={`Task: ${person.task_name || ''}`}>
                <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: 140, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                {/* {projectData?.project_category !== 12 ? `Task:  ${person.task_name}` : 'Install Labor'} */}
                {(projectData?.project_category !== 12 || projectData?.project_category == 12) ? (
                    <>
                      <Box component="span" color="text.secondary">
                        Task:{' '}
                      </Box>
                      <Box component="span" color="yellow">
                        {person.task_name}
                      </Box>
                    </>
                  ) : (
                    <Box component="span" color="yellow">
                      Install Labor
                    </Box>
                  )}
                </Typography>
              </Tooltip>}
            </Stack>
          </Box>
          <Stack direction='column' textAlign={'right'}>
            <Tooltip
              title={
                `${person.hours} ${person.hours === 1 ? 'hour' : 'hours'}
                 ${person.minutes ? ` ${person.minutes} min` : ''}`}
            >
              <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: 140, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                {person.hours} {person.hours === 1 ? 'hour' : 'hours'}
                {person.minutes ? ` ${person.minutes} min` : ''}
              </Typography>
            </Tooltip>
            {person?.installation ? '' : (<Tooltip title={`Subtask: ${person.subtask_name || ''}`}>
              <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: 140, textOverflow: 'ellipsis', overflow: 'hidden' }}>
              {(projectData?.project_category !== 12 || projectData?.project_category == 12) ? `Subtask: ${person?.subtask_name} ` : ''}
              </Typography>
            </Tooltip>)}
          </Stack>
        </>
      </Stack>

      {showDivider && <Divider />}
    </Box>
  );
}

LaborerRow.propTypes = {
  person: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    subTaskName: PropTypes.string,
    taskName: PropTypes.string,
    hours: PropTypes.number,
    minutes: PropTypes.number,
    avatar: PropTypes.string,
  }),
  showDivider: PropTypes.bool,
  loading: PropTypes.bool,
};

// ----------------------------------------------------------------------

function HourerControlsRow({ person, onSave, loading, convertDecimalToTime, taskName, subtaskName, loadingId, editingId, setEditingId }) {
  const [editing, setEditing] = useState(false);

  const [h, setH] = useState(person?.total_hours);
  const [m, setM] = useState(person?.total_minutes);

  const clamp = (v, min, max) =>
    Math.min(Math.max(Number.isFinite(v) ? v : 0, min), max);

  const handleSave = () => {
    console.log('personperson', person)
    setEditing(false);
    onSave?.({ id: person.id, hours: h, minutes: m, person });
  };

  const decH = () => setH((v) => clamp(v - 1, 0, 999));
  const incH = () => setH((v) => clamp(v + 1, 0, 999));
  const decM = () => setM((v) => clamp(v - 1, 0, 60));
  const incM = () => setM((v) => {
    const newVal = v + 1;
    return newVal > 60 ? 60 : newVal;
  });

  const myId = `${person.staff_user_id}-${person.task_id}-${person.subtask_id}`;
  const anotherRowEditing = Boolean(editingId && editingId !== myId);

  const handleEditButtonClick = () => {
    if (editing) {
      handleSave();
      return;
    }
    if (anotherRowEditing) return;
    setEditing(true);
    setEditingId?.(myId);
  };

  return (
    <Grid container direction="row" alignItems="center" wrap="nowrap" spacing={0} sx={{ gap: 1.5 }}>
      <Grid item xs style={{ minWidth: 220 }}>
        <TextField
          fullWidth
          size="small"
          label="Hours"
          value={h}
          onChange={(e) => setH(clamp(parseInt(e.target.value || '0', 10), 0, 999))}
          disabled={!editing}
          inputProps={{ style: { textAlign: 'center' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton size="small" disabled={!editing} onClick={decH} edge="start">
                  <Remove fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" disabled={!editing} onClick={incH} edge="end">
                  <Add fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs style={{ minWidth: 220 }}>
        <TextField
          fullWidth
          size="small"
          label="Minutes"
          value={m}
          onChange={(e) => setM(clamp(parseInt(e.target.value || '0', 10), 0, 59))}
          disabled={!editing}
          inputProps={{ style: { textAlign: 'center' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton size="small" disabled={!editing} onClick={decM} edge="start">
                  <Remove fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="caption" color="textSecondary">min</Typography>
                  <IconButton size="small" disabled={!editing} onClick={incM} edge="end">
                    <Add fontSize="small" />
                  </IconButton>
                </Box>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item>
        <IconButton size="small" onClick={handleEditButtonClick} disabled={anotherRowEditing}>
          {loadingId === `${person.staff_user_id}-${person.task_id}-${person.subtask_id}` ? (
            <CircularProgress size={24} />  // Show CircularProgress while saving for this specific item
          ) : (
            editing ? <DoneIcon /> : <EditOutlined sx={{ opacity: anotherRowEditing ? 0.4 : 1 }} />
          )}
        </IconButton>
      </Grid>
    </Grid>
  );
}

HourerControlsRow.propTypes = {
  person: PropTypes.shape({
    id: PropTypes.string,
    hours: PropTypes.number,
    minutes: PropTypes.number,
  }),
  onSave: PropTypes.func,
  loading: PropTypes.bool,
  taskName: PropTypes.string,      // Add prop types
  subtaskName: PropTypes.string,  // Add prop types
  editingId: PropTypes.string,
  setEditingId: PropTypes.func,
};

// ----------------------------------------------------------------------
// Page
export default function JobCostMemberClockInTimer({
  userId,
  userType,
  projectData,
  fetchData,
  fetchJobCostLogs,
}) {
  console.log('projectData+++++++++---------', projectData)
  const [rows, setRows] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const projectId = projectData?.id;
  const [loadingId, setLoadingId] = useState(null);
  const [editingId, setEditingId] = useState(null);

  const SKELETON_COUNT = 4;

  const handleSaveRow = async ({ id, hours, minutes, person }) => {
    const uniqueId = `${person.staff_user_id}-${person.task_id}-${person.subtask_id}`;
    setLoadingId(uniqueId);
    setEditingId(uniqueId);
    console.log('hours******', hours)
    console.log('minutes***', minutes)
    console.log('id', id)

    const previousTotalHours = person.total_hours || 0;
    const previousTotalMinutes = person.total_minutes || 0;

    const newTotalMinutes = (Number(hours) || 0) * 60 + (Number(minutes) || 0);
    const newTotalHours = newTotalMinutes / 60;

    const deltaMinutes = newTotalMinutes - (previousTotalHours * 60 + previousTotalMinutes);
    const hourDecimal = +(deltaMinutes / 60).toFixed(4);

    const end_time = moment().unix();

    const start_time = end_time - deltaMinutes * 60;

    // Prepare the payload
    const taskId = person?.task_id ?? null;
    const subtask_id = person?.subtask_id ?? null;
    const task_id = person?.task_id ?? null;
    const staff_user_id = person?.staff_user_id ?? null;
    const staff_id = person?.staff_id ?? null;

    const payload = {
      projectId,
      taskId,
      userId,
      person,
      minutesCurrent: minutes,
      hoursCurrent: hours,
      memberClockins: [
        {
          staff_id,
          userId: staff_user_id,
          hour: hourDecimal,
          subtask_id,
          task_id,
          start_time,
          end_time,
          service_id : person?.service_id ? person?.customer_order_product_id : null,
          hourly_rate: person?.hourly_rate || 0,
        },
      ],
      project_category: projectData?.project_category,
      now: end_time,
      checkedItems: [id],
    };

    try {
      const res = await axios.post(
        `${REST_API_END_POINT}project-task/update-staff-task-timelog`,
        payload
      );

      if (res.data.status === 1) {
        enqueueSnackbar('Time log updated successfully', { variant: 'success' });
        fetchUsersByTask();
        fetchJobCostLogs();
        fetchData(true);
      } else {
        enqueueSnackbar('Failed to update time log', { variant: 'error' });
      }
    } catch (err) {
      console.error('❌ API Error:', err);
      enqueueSnackbar('Failed to update time log', { variant: 'error' });
    } finally {
      setLoadingId(null);  // Reset loading state after request completion
      setEditingId(null);
    }
  };

  const convertDecimalToTime = (decimalHours) => {
    const hours = Math.floor(decimalHours);
    console.log('hours-------------', hours)
    const minutes = Math.round((decimalHours - hours) * 60); // Convert fractional part to minutes
    console.log('minutes-------------', minutes)
    return { hours, minutes };
  };

  const fetchUsersByTask = async () => {
    try {
      const projectCategory = projectData?.project_category !== 12;
      // let endpoint = projectCategory ? `${REST_API_END_POINT}project/get-all-users-by-tasks` : `${REST_API_END_POINT}project/get-all-users-by-time-and-material`;
      let endpoint = projectCategory ? `${REST_API_END_POINT}project/get-all-users-by-tasks` : `${REST_API_END_POINT}project/get-all-users-by-tasks`;
      setLoading(true);
      // const res = await axios.post(`${REST_API_END_POINT}project/get-all-users-by-time-and-material`, {
        const res = await axios.post(`${endpoint}`, {
        project_id: projectId,
        userType,
        userId,
      });

      if (res.data.status === 1 && res.data.data) {
        const mappedRows = res.data.data.map((user) => {
          const hours = user.total_hours || 0;
          const minutes = user.total_minutes || 0;
          return {
            ...user,
            hours,
            minutes,
            taskName: user.task_name,
            subtaskName: user.subtask_name,
          };
        });
        setRows(mappedRows);
      }
    } catch (error) {
      console.error('Error fetching users by task:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchUsersByTask();
      console.log('projectId', projectId)
    }
  }, [projectId]);

  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      {/* Left: Laborer */}
      <Grid item xs={12} md={6}>
        <Typography variant="h6">Laborer</Typography>
        <Scrollbar sx={{ overflow: 'auto', maxHeight: 400, minHeight: 150 }}>
          <Stack>
            <Card variant="outlined" sx={{ mt: 1 }}>
              <Box sx={{ px: 2, pb: 1 }}>
                {loading ? (
                  [...Array(SKELETON_COUNT)].map((_, idx) => (
                    <Box key={idx}>
                      <Stack direction="row" alignItems="center" spacing={2} sx={{ py: 0.8, mt: 1 }}>
                        <Skeleton variant="circle" width={40} height={40} />
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                          <Skeleton variant="text" width="60%" height={20} />
                          <Skeleton variant="text" width="50%" height={15} />
                        </Box>
                        <Skeleton variant="text" width="30%" height={20} />
                      </Stack>
                      {idx !== SKELETON_COUNT - 1 && <Divider />}
                    </Box>
                  ))
                ) : rows.length === 0 ? (
                  <Box sx={{ py: 4, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No laborers found</Typography>
                  </Box>
                ) : (
                  rows.map((p, idx) => (
                    <LaborerRow
                      key={p.id}
                      person={p}
                      loading={loading}
                      showDivider={idx !== rows.length - 1}
                      projectData={projectData}
                    />
                  ))
                )}
              </Box>
            </Card>
          </Stack>
        </Scrollbar>
      </Grid>

      {/* Right: Hours */}
      <Grid item xs={12} md={6}>
        <Typography variant="h6">Hours</Typography>
        <Scrollbar sx={{ overflow: 'auto', maxHeight: 400, minHeight: 150 }}>
          <Stack sx={{ width: 'fit-content', minWidth: 180, maxWidth: 1600, }}>
            <Card variant="outlined" sx={{ mt: 1 }}>
              <Stack spacing={3} sx={{ p: 3 }}>
                {loading ? (
                  [...Array(SKELETON_COUNT)].map((_, idx) => (
                    <Grid key={idx} container direction="row" alignItems="center" wrap="nowrap" spacing={0} sx={{ gap: 1.5 }}>
                      <Grid item xs style={{ minWidth: 220 }}>
                        <Skeleton variant="rect" width="100%" height={40} />
                      </Grid>
                      <Grid item xs style={{ minWidth: 220 }}>
                        <Skeleton variant="rect" width="100%" height={40} />
                      </Grid>
                      <Grid item>
                        <Skeleton variant="circle" width={40} height={40} />
                      </Grid>
                    </Grid>
                  ))
                ) : rows.length === 0 ? (
                  <Box sx={{ py: 4, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">No hour data available</Typography>
                  </Box>
                ) : (
                  rows.map((p) => {
                    console.log('personnnnnnnnnnn', p)
                    return (
                      <HourerControlsRow
                        key={p.id}
                        person={p}
                        onSave={handleSaveRow}
                        loading={loading}
                        convertDecimalToTime={convertDecimalToTime}
                        taskName={p.taskName}    // Pass taskName
                        subtaskName={p.subtaskName}  // Pass subtaskName
                        loadingId={loadingId}
                        editingId={editingId}
                        setEditingId={setEditingId}
                      />
                    )
                  })
                )}
              </Stack>
            </Card>
          </Stack>
        </Scrollbar>
      </Grid>
    </Grid>
  );
}